<template>
    <!-- The marker beside a weight figure that rests on only some of a Section's cameras. Absent
         whenever the figure is whole, so its presence is the whole signal - there is no neutral
         state to read past. Amber rather than red: a partial figure is still a figure, and the
         tile deliberately keeps showing it rather than blanking. -->
    <span v-if="isDegraded" class="cursor-help" :title="caveat">
        <CameraOff class="h-3.5 w-3.5 shrink-0 text-amber-500" aria-hidden="true" />
    </span>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { CameraOff } from 'lucide-vue-next';
import { i18n } from '@/plugins/internationalization/i18n';

const props = defineProps<{
    // Cameras that reported a weight inside the staleness window, and cameras mounted on the Section
    // right now. Contributing is null on any row whose weight figure is itself absent - there is
    // nothing for a caveat to qualify then - and expected on a row the live-KPI read covers not at
    // all, which is the same row.
    contributing: number | null;
    expected: number | null;
}>();

// Strictly fewer, never a subtraction. A camera unmounted within the staleness window reported
// inside it while no longer being mounted, so `contributing` can legitimately exceed `expected` -
// treating that as a shortfall would render "based on 3 of 2 cameras", or worse a negative count.
const isDegraded = computed(() => props.contributing !== null && props.expected !== null && props.contributing < props.expected);

const caveat = computed(() =>
    i18n.global.t('views.monitoring.activeGroups.texts.camerasDegraded', {
        contributing: props.contributing,
        expected: props.expected,
    })
);
</script>
